// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fdc72df6","389":"020bd386","732":"b5e3bfe3","977":"c2975db9"}[chunkId] + ".chunk.js";
};